<template>
  <div class="logo" :style="cssVars">
    <img v-if="!isWhite" alt="" src="../assets/Logo.png">
    <img v-if="isWhite" alt="" src="../assets/Logo-white.png">
    <div class="app-name">CorpLens</div>
  </div>
</template>

<script>
export default {
  name: "LogoTitle",
  props: {
    isWhite: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    cssVars() {
      return {
        '--app-name-color': this.isWhite ? '#FFF' : '#2468E6',
        '--app-logo-size': this.isWhite ? '40px' : '60px',
        '--app-logo-radius': this.isWhite ? '10px' : '12px',
        '--app-name-size': this.isWhite ? '32px' : '55px',
        '--app-margin-top': this.isWhite ? '0' : '24px',
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  padding-top: var(--app-margin-top);
  display: flex;
  align-items: center;

  .app-name {
    font-size: var(--app-name-size);
    font-weight: 1000;
    margin-left: 16px;
    color: var(--app-name-color);
  }

  img {
    border-radius: var(--app-logo-radius);
    width: var(--app-logo-size);
    height: var(--app-logo-size);
  }
}

@media screen and (max-width: 1000px) {
  .logo {
  padding-top: var(--app-margin-top);

  .app-name {
    font-size: 1.2rem;
    margin-left: 0.6rem;
  }

  img {
    border-radius: 0.4rem;
    width: 1.6rem;
    height: 1.6rem;
  }
}
}
</style>